import './BookmarkButton.css'
import * as React from 'react';
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from '@mui/icons-material/Star';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip
} from "@mui/material";
import {NavLink, withRouter} from "react-router-dom";
import Divider from "@mui/material/Divider";
import {isLoggedIn} from "../../Functions/Authentication";
import TitleWithText from "../TitleWithText/TitleWithText";
import {getCurrentPageURL} from "../../Functions/CurrentPage";
import {LoadingButton} from "@mui/lab";

class BookmarkButton extends React.Component {
  state = {
    bookmarked: false,
    loginDialog: false,
    loading: false
  }

  componentDidMount() {
    if (this.props.lazyLoad && isLoggedIn()) {
      fetch(`/api/${this.props.itemType}/${this.props.itemId}/bookmark`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error(response.status.toString())
        }
      })
      .then(bookmarked => {
        this.setState({bookmarked: bookmarked === "true"});
      })
      .catch(console.log);
    } else {
      this.setState({bookmarked: this.props.bookmarked})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.bookmarked !== prevProps.bookmarked) {
      this.setState({bookmarked: this.props.bookmarked})
    }
  }

  removeBookmark() {
    if (isLoggedIn()) {
      this.setState({loading: true});

      fetch(`/api/${this.props.itemType}/${this.props.itemId}/bookmark`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status === 401) {
          this.setState({loginDialog: true, loading: false});
        } else if (response.ok) {
          this.setState({bookmarked: false, loading: false});

          if (this.props.onBookmarkChange) {
            this.props.onBookmarkChange(this.props.itemId, false)
          }
        }
      })
      .catch(console.log);
    } else {
      this.setState({loginDialog: true});
    }
  }

  bookmark() {
    if (isLoggedIn()) {
      this.setState({loading: true});

      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(recaptchaKey, {action: 'submit'}).then(
            function (token) {
              fetch(`/api/${this.props.itemType}/${this.props.itemId}/bookmark`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Captcha-Token': token
                }
              })
              .then(response => {
                if (response.status === 401) {
                  this.setState({loginDialog: true, loading: false});
                } else if (response.ok) {
                  this.setState({bookmarked: true, loading: false})

                  if (this.props.onBookmarkChange) {
                    this.props.onBookmarkChange(this.props.itemId, true)
                  }
                }
              })
              .catch(console.log);
            }.bind(this));
      }.bind(this));
    } else {
      this.setState({loginDialog: true});
    }
  }

  handleClose() {
    this.setState({loginDialog: false});
  }

  render() {
    return (
        <React.Fragment>
          <Tooltip title={this.state.loading ? "Loading..." : (this.state.bookmarked ? "Remove from Favourite" : "Add to Favourite")}>
            {
              this.state.bookmarked
                  ? (
                      this.props.variant === "button"
                          ? <LoadingButton loading={this.state.loading} variant="outlined" startIcon={<StarIcon/>} onClick={this.removeBookmark.bind(this)}>Remove from Favourite</LoadingButton>
                          : (this.state.loading ? <CircularProgress size={44} /> : <StarIcon className={"bookmark-icon"} onClick={this.removeBookmark.bind(this)}/>)
                  )
                  : (
                      this.props.variant === "button"
                          ? <LoadingButton loading={this.state.loading} variant="outlined" startIcon={<StarBorderIcon/>} onClick={this.bookmark.bind(this)}>Add to Favourite</LoadingButton>
                          : (this.state.loading ? <CircularProgress size={44} /> : <StarBorderIcon className={"bookmark-icon"} onClick={this.bookmark.bind(this)}/>)
                  )
            }
          </Tooltip>
          {
            this.state.loginDialog &&
            <Dialog open={this.state.loginDialog} onClose={this.handleClose.bind(this)}>
              <DialogContent>
                <DialogContentText>
                  <TitleWithText title={"Add book to favourites?"}>
                    You must login to perform this action.
                    <br/><br/>
                    Login or register now, and access the many benefits only available to registered members.
                  </TitleWithText>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" component={NavLink} to={{pathname: '/login', state: {redirectTo: getCurrentPageURL()}}}>Login</Button>
                <Button variant="outlined" component={NavLink} to={"/register"}>Register</Button>
                <Divider style={{marginLeft: "8px", marginRight: "8px"}} orientation="vertical" variant="middle" flexItem/>
                <Button variant="contained" onClick={this.handleClose.bind(this)}>Cancel</Button>
              </DialogActions>
            </Dialog>
          }
        </React.Fragment>
    );
  }
}

export default withRouter(BookmarkButton);
